export const FETCH_FOLDER_BEGIN = 'FETCH_FOLDER_BEGIN'
export const FETCH_FOLDER_SUCCESS = 'FETCH_FOLDER_SUCCESS'
export const FETCH_FOLDER_FAILURE = 'FETCH_FOLDER_FAILURE'
export const SET_FOLDER_CONTENT = 'SET_FOLDER_CONTENT'
export const SET_FOLDER = 'SET_FOLDER'
